export default __webpack_public_path__ + "static/media/Razzo-rosso-svg.bbc3b983.svg";